import React from "react";
import { createRoot } from 'react-dom/client';
import Root from "./Root";
import * as Sentry from "@sentry/react";

import "./css/vars.css";
import "./css/reset.css";
import "./css/index.css";
import "./css/admin.css";
import "./css/date-picker.css";

Sentry.init({
  dsn: "https://4ff58d286ab31a5f8e6d9e759d9c0860@o195104.ingest.us.sentry.io/4509448347385856",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: process.env.NODE_ENV || "development",
  enabled: process.env.NODE_ENV === "production" || process.env.NODE_ENV === "staging",
});

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);